import { render, staticRenderFns } from "./ConsolidationUnionsType.vue?vue&type=template&id=5c3633e9&scoped=true"
import script from "./ConsolidationUnionsType.vue?vue&type=script&lang=js"
export * from "./ConsolidationUnionsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3633e9",
  null
  
)

export default component.exports